module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-wedding3-56c1e156ca85faad1aea9d055acfcd64.jpg";